/**
 * 表の中の値に状態の色を付ける(設計書 §3: 色だけで伝えない → 超過・注意は印も付け、読み上げには文字で伝える)。
 * どの状態かは呼び出し側が決める。業務ロジックは持たない。
 *  - good: 良い(緑の太字) / over: 目標超過(赤字＋印) / warn: 注意(黄褐色＋印) / negative: マイナス(赤字。符号が意味を持つ) / muted: 0 など薄く
 */
import type { ReactNode } from 'react';
import { IconAlertCircle, IconAlertTriangle } from '@core/components/icons';

export type ValueTone = '' | 'good' | 'over' | 'warn' | 'negative' | 'muted';

const SR_TEXT: Partial<Record<ValueTone, string>> = { good: '(良い)', over: '(超過)', warn: '(注意)' };

export default function ToneValue({ tone = '', srText, children }: { tone?: ValueTone; /** 読み上げの言葉を変える(例: 目標未達は「(未達)」。2026-10-14 追加) */ srText?: string; children: ReactNode }) {
  if (!tone) return <>{children}</>;
  return (
    <span className={`tone-value is-${tone}`}>
      {tone === 'over' && <IconAlertCircle size={12} />}
      {tone === 'warn' && <IconAlertTriangle size={12} />}
      {children}
      {(srText ?? SR_TEXT[tone]) && <span className="sr-only">{srText ?? SR_TEXT[tone]}</span>}
    </span>
  );
}
